import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the easySplitPayments state domain
 */

const selectEasySplitPaymentsDomain = state =>
  state.easySplitPayments || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by EasySplitPayments
 */

const makeSelectEasySplitPayments = () =>
  createSelector(
    selectEasySplitPaymentsDomain,
    substate => substate,
  );

export default makeSelectEasySplitPayments;
export { selectEasySplitPaymentsDomain };
